import { Badge } from '@optiaxiom/react';

import type { Notification } from '../../../types';
import { getPriority } from '../../../utils';

type PriorityCellProps = {
  notification: Notification;
};

export function PriorityCell({ notification }: PriorityCellProps) {
  const priority = getPriority(notification.type);
  const intent = priority === 'High' ? 'danger' : 'neutral';

  return <Badge intent={intent}>{priority}</Badge>;
}
